export default "__VITE_ASSET__7a4ba8d4__"